import React, { useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useLocation } from "react-router";
import { makeStyles } from "@material-ui/core/styles";
import { localApi, credentials, localApib2b } from "utils/imgApi";
import Compressor from "compressorjs";
import ReactCrop from "react-image-crop";
import "react-image-crop/dist/ReactCrop.css";
import { dataURLtoFile } from "utils/dataURLToFile";
import PropTypes from "prop-types";
import Axios from "axios";

import CardAvatar from "components/Card/CardAvatar.js";
import defaultAvatar from "assets/img/placeholder.jpg";
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Button from "components/CustomButtons/Button.js";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import SweetAlert from "react-bootstrap-sweetalert";

import styles from "assets/jss/material-dashboard-pro-react/views/loginPageStyle.js";
import styleDrop from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.js";
import styleSweet from "assets/jss/material-dashboard-pro-react/views/sweetAlertStyle.js";
import styleBtn from "assets/jss/material-dashboard-pro-react/views/userProfileStyles.js";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

const style = {
    cardTitle,
    pageSubcategoriesTitle: {
        color: "#3C4858",
        textDecoration: "none",
        textAlign: "center",
    },
    cardCategory: {
        margin: "0",
        color: "#999999",
    },
};

const useStyles = makeStyles(styles);
const useStyle = makeStyles(style);
const useStyleDrop = makeStyles(styleDrop);
const useStyleSweet = makeStyles(styleSweet);
const useStyleBtn = makeStyles(styleBtn);

export default function ImagesAddClientProfile(props) {
    const [logoImg, setLogoImg] = React.useState("");
    const [firstname, setFristname] = React.useState("");
    const [lastname, setLastname] = React.useState("");
    const [submittedLogo, setSubmittedLogo] = React.useState(false);
    const [submittedDeleteLogo, setSubmittedDeleteLogo] = React.useState(false);
    const [userData, setUserData] = React.useState({});
    const [type, setType] = React.useState("");

    const [proImg, setProImg] = React.useState("");

    const [alertType, alertTypeOps] = React.useState("");
    const [alertMsg, alertMsgOps] = React.useState("");
    const [submitted, setSubmitted] = React.useState(false);
    const [submittedSign, setSubmittedSign] = React.useState(false);
    const [newImage, setNewImage] = React.useState(false);
    const [btn, setBtn] = React.useState(false);

    const classes = useStyles();
    const classe = useStyle();
    const classDrop = useStyleDrop();
    const history = useHistory();
    const classSweet = useStyleSweet();
    const classBtn = useStyleBtn();

    const { search } = useLocation();
    const a = new URLSearchParams(search).get("a");

    const [file, setFile] = React.useState(null);
    const [crop, setCrop] = React.useState({
        aspect: 840 / 1134,
        unit: "px",
        width: 280,
        height: 336,
    });
    const [image, setImage] = React.useState("");
    const [result, setResult] = React.useState("");
    const [imagePreviewUrl, setImagePreviewUrl] = React.useState("");

    let fileInput = React.createRef();

    const handleImageChange = (e) => {
        e.preventDefault();
        let reader = new FileReader();
        let file = e.target.files[0];
        reader.onloadend = () => {
            setFile(file);
            setImagePreviewUrl(reader.result);
        };
        if (file) {
            reader.readAsDataURL(file);
        }
    };

    const handleClick = () => {
        fileInput.current.click();
    };

    const handleRemove = () => {
        setFile(null);
        setImagePreviewUrl("");
        fileInput.current.value = null;
    };

    async function getCat() {
        const api = localApib2b + `/register/find/byId/${a}`;
        const result = await fetch(api, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const getResult = await result.json();
        // console.log(getResult);

        setUserData(getResult);
        setFristname(getResult.firstname);
        setLastname(getResult.lastname);
        setProImg(getResult.profileUrl + "?id=" + getResult.id);

        const apiType = localApib2b + `/type/list`;
        const resultType = await fetch(apiType, {
            method: "GET",
            headers: {
                Authorization: `Basic ${credentials}`,
            },
        });
        const getResultType = await resultType.json();
        const typeDes = getResultType.TypeList.filter((f) => f.typeId === getResult.typeId)[0];
        setType(typeDes);
    }

    useEffect(() => {
        getCat();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!file) {
            // alert("Please upload an image.");
            alertTypeOps("danger");
            alertMsgOps("Please upload an image.");
            setSubmitted(true);
            return;
        }

        const img = new Image();
        const objectUrl = URL.createObjectURL(file);

        img.onload = async () => {
            if (img.width === 840 && img.height === 1124) {
                let fData = new FormData();
                fData.append("profileImage", file);

                try {
                    const response = await Axios.put(
                        localApib2b + `/register/update/profile/findById/${a}`,
                        fData,
                        {
                            headers: {
                                Authorization: `Basic ${credentials}`,
                            },
                        }
                    );

                    if (response.data.message === "Data Updated Successfully !!!") {
                        alertTypeOps("success");
                        alertMsgOps("Successfully updated!");
                        setSubmittedSign(true);
                    }
                } catch (error) {
                    // console.error("Upload failed:", error);
                    // alert("Failed to upload image.");
                    alertTypeOps("danger");
                    alertMsgOps("Failed to upload image.");
                    setSubmitted(true);
                }
            } else {
                // alert("Image dimensions must be 840x1124 pixels.");
                alertTypeOps("danger");
                alertMsgOps("Image dimensions must be 840x1124 pixels.");
                setSubmitted(true);
            }

            // Clean up the object URL
            URL.revokeObjectURL(objectUrl);
        };

        img.onerror = () => {
            // alert("Invalid image file.");
            alertTypeOps("danger");
            alertMsgOps("Invalid image file.");
            setSubmitted(true);
            URL.revokeObjectURL(objectUrl);
        };

        img.src = objectUrl;
    };

    const hideAlert = () => {
        setSubmitted(false);
        setSubmittedSign(false);
        window.location.reload(false);
    };

    let { avatar, addButtonProps, changeButtonProps, removeButtonProps } = props;

    return (
        <div className={classes.container}>
            {submitted && (
                <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={classSweet.button + " " + classSweet.success}
                />
            )}
            {submittedSign && (
                <SweetAlert
                    type={alertType}
                    style={{ display: "block", marginTop: "-100px" }}
                    title={alertMsg}
                    onConfirm={() => hideAlert()}
                    confirmBtnCssClass={classSweet.button + " " + classSweet.success}
                >
                    Updated Client Profile Image
                </SweetAlert>
            )}
            <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                    <Card profile>
                        <CardAvatar profile>
                            <a href="#pablo" onClick={(e) => e.preventDefault()}>
                                <img src={proImg} alt="..." />
                            </a>
                        </CardAvatar>
                        <CardBody profile>
                            <h5 className={classBtn.cardCategory}>
                                {/* CEO / CO-FOUNDER */}
                                {type.descType}
                            </h5>
                            <h3 className={classBtn.cardTitle}>
                                {firstname + " " + lastname}
                            </h3>
                            <p className={classBtn.description}>
                                In this ever-changing society, the most powerful and enduring
                                brands are built from the heart. They are real and sustainable.
                            </p>

                            <legend>
                                My Profile Image* <br /> Image dimension Must be 840x1124
                            </legend>
                            <div className="fileinput text-center">
                                <input
                                    type="file"
                                    onChange={handleImageChange}
                                    ref={fileInput}
                                />
                                {file && (
                                    <div className={"thumbnail" + (avatar ? " img-circle" : "")}>
                                        <img src={imagePreviewUrl} alt="..." />
                                    </div>
                                )}

                                <div>
                                    {file === null ? (
                                        <Button
                                            color="rose"
                                            round
                                            {...addButtonProps}
                                            onClick={() => handleClick()}
                                        >
                                            {avatar ? "Select" : "Select"}
                                        </Button>
                                    ) : (
                                        <span>
                                            <Button
                                                color="rose"
                                                round
                                                {...changeButtonProps}
                                                onClick={() => handleClick()}
                                            >
                                                Change
                                            </Button>
                                            {avatar ? <br /> : null}
                                            <Button
                                                color="rose"
                                                round
                                                {...removeButtonProps}
                                                onClick={() => handleRemove()}
                                            >
                                                <i className="fas fa-times" /> Remove
                                            </Button>
                                            <Button color="rose" round onClick={handleSubmit}>
                                                upload
                                            </Button>
                                        </span>
                                    )}
                                </div>
                            </div>
                        </CardBody>
                    </Card>
                </GridItem>
            </GridContainer>
        </div>
    );
}

ImagesAddClientProfile.propTypes = {
    avatar: PropTypes.bool,
    addButtonProps: PropTypes.object,
    changeButtonProps: PropTypes.object,
    removeButtonProps: PropTypes.object,
};
